(function(){
var r=document.getElementById('hx-root');
if(!r||r.getAttribute('data-on'))return;
r.setAttribute('data-on','1');
var hdr=document.getElementById('shopify-section-header');
var jump=r.querySelector('.hx-jump');
function sbw(){var d=document.documentElement;d.style.setProperty('--hx-sbw',Math.max(0,window.innerWidth-d.clientWidth)+'px')}
function place(){
  var t=0;
  if(hdr){var b=hdr.getBoundingClientRect().bottom;t=b>0?Math.round(b):0}
  r.style.setProperty('--hx-top',t+'px');
}
place();
var t1;function later(){place();clearTimeout(t1);t1=setTimeout(place,350);setTimeout(place,900)}
if(window.ResizeObserver&&hdr){new ResizeObserver(place).observe(hdr)}
window.addEventListener('scroll',later,{passive:true});
window.addEventListener('resize',function(){sbw();place()});
sbw();
var links=[].slice.call(r.querySelectorAll('.hx-jump a'));
var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
links.forEach(function(a){
  a.addEventListener('click',function(e){
    var id=a.getAttribute('href').slice(1);var el=document.getElementById(id);
    if(!el)return;
    e.preventDefault();
    el.scrollIntoView({behavior:reduce?'auto':'smooth',block:'start'});
  });
});
if('IntersectionObserver' in window){
  var secs=links.map(function(a){return document.getElementById(a.getAttribute('href').slice(1))}).filter(Boolean);
  var so=new IntersectionObserver(function(es){
    es.forEach(function(en){
      if(!en.isIntersecting)return;
      links.forEach(function(a){
        var on=a.getAttribute('href')==='#'+en.target.id;
        if(on){a.setAttribute('aria-current','true');var bar=a.parentNode;if(bar.scrollWidth>bar.clientWidth){bar.scrollTo({left:a.offsetLeft-bar.clientWidth/3,behavior:reduce?'auto':'smooth'})}}
        else a.removeAttribute('aria-current');
      });
    });
  },{rootMargin:'-30% 0px -60% 0px'});
  secs.forEach(function(s){so.observe(s)});
  r.classList.add('is-live');
  var io=new IntersectionObserver(function(es){
    es.forEach(function(en){if(en.isIntersecting){en.target.classList.add('is-in');io.unobserve(en.target)}});
  },{rootMargin:'0px 0px -8% 0px'});
  [].slice.call(r.querySelectorAll('[data-r]')).forEach(function(n){io.observe(n)});
}

var jb=r.querySelector('.hx-jump'),jin=jb&&jb.querySelector('.hx-in'),thumb=jb&&jb.querySelector('.hx-jump-track i');
function jstate(){if(!jin)return;var sw=jin.scrollWidth,cw=jin.clientWidth,m=sw-cw;var can=m>4;jb.classList.toggle('is-scrollable',can);jb.classList.toggle('is-more',can&&jin.scrollLeft<m-4);jb.classList.toggle('is-scrolled',jin.scrollLeft>4);
 if(thumb&&can){var w=cw/sw;thumb.style.width=(w*100)+'%';thumb.style.transform='translateX('+((jin.scrollLeft/m)*(1-w)/w*100)+'%)'}}
if(jin){jin.addEventListener('scroll',function(){jb.classList.remove('is-fresh');jstate()},{passive:true});window.addEventListener('resize',jstate);jb.classList.add('is-fresh');jstate();
 if(!reduce&&'IntersectionObserver' in window&&jin.scrollWidth>jin.clientWidth+4){var nd=new IntersectionObserver(function(es){if(es[0].isIntersecting){nd.disconnect();setTimeout(function(){if(jin.scrollLeft>4)return;jin.scrollTo({left:56,behavior:'smooth'});setTimeout(function(){jin.scrollTo({left:0,behavior:'smooth'});setTimeout(function(){jb.classList.add('is-fresh')},700)},800)},900)}});nd.observe(jb)}}
[].forEach.call(r.querySelectorAll('.hx-gal'),function(g){
 var tr=g.querySelector('.hx-gal-track'),view=g.querySelector('.hx-gal-view'),pos=g.querySelector('.hx-gal-pos'),bs=g.querySelectorAll('.hx-gal-btn');if(!tr)return;
 var items=tr.children;
 function step(){var a=items[0],b=items[1];return a?(b?b.offsetLeft-a.offsetLeft:a.offsetWidth):tr.clientWidth}
 function st(){var s=step()||1,m=tr.scrollWidth-tr.clientWidth,i=Math.min(items.length,Math.round(tr.scrollLeft/s)+1);if(pos)pos.textContent=i;
  if(bs[0])bs[0].disabled=tr.scrollLeft<=4;if(bs[1])bs[1].disabled=tr.scrollLeft>=m-4;if(view)view.classList.toggle('is-end',tr.scrollLeft>=m-4)}
 var tk;tr.addEventListener('scroll',function(){if(tk)return;tk=requestAnimationFrame(function(){tk=0;st()})},{passive:true});
 [].forEach.call(bs,function(b){b.addEventListener('click',function(){var n=Math.max(1,Math.floor(tr.clientWidth/step()));tr.scrollBy({left:(+b.getAttribute('data-d'))*n*step(),behavior:reduce?'auto':'smooth'})})});
 tr.addEventListener('keydown',function(e){if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();tr.scrollBy({left:(e.key==='ArrowRight'?1:-1)*step(),behavior:reduce?'auto':'smooth'})}});
 window.addEventListener('resize',st);st();
});

(function(){if(!document.getElementById('smart-dock-nav'))return;
 document.documentElement.classList.add('hx-dockctl');
 var tick=false,last=null;
 function upd(){tick=false;var nav=document.getElementById('smart-dock-nav');if(!nav)return;var atc=document.querySelector('.js-product-add'),ft=document.getElementById('shopify-section-footer'),vh=window.innerHeight,show;
  if(atc&&atc.offsetParent!==null){show=atc.getBoundingClientRect().bottom<0}else{show=window.scrollY>vh}
  if(show&&ft&&ft.getBoundingClientRect().top<vh)show=false;
  if(show!==last||!nav.classList.contains('hx-show')===show){last=show;nav.classList.toggle('hx-show',show);nav.setAttribute('aria-hidden',show?'false':'true');[].forEach.call(nav.querySelectorAll('button,input,a'),function(x){x.tabIndex=show?0:-1})}}
 function req(){if(!tick){tick=true;requestAnimationFrame(upd)}}
 window.addEventListener('scroll',req,{passive:true});window.addEventListener('resize',req);
 upd();
})();

[].forEach.call(r.querySelectorAll('.hx-roi'),function(w){
 var run=parseFloat(w.getAttribute('data-run'))||0,ins=w.querySelectorAll('input[data-k]');
 function f(n){return '\u00a3'+Math.round(n).toLocaleString('en-GB')}
 function o(k,v){var e=w.querySelector('[data-o="'+k+'"]');if(e)e.textContent=v}
 function calc(){var v={};[].forEach.call(ins,function(i){v[i.getAttribute('data-k')]=+i.value});
  var gross=v.rate*365*(v.occ/100)*v.units,cost=run*365*v.units,net=Math.max(0,gross-cost);
  o('rate',f(v.rate));o('occ',v.occ+'%');o('units',v.units);o('gross',f(gross));o('run',f(cost));o('net',f(net))}
 [].forEach.call(ins,function(i){i.addEventListener('input',calc)});calc();
});
var tog=r.querySelectorAll('.hx-tog button');
[].forEach.call(tog,function(b){
  b.addEventListener('click',function(){
    var c=b.getAttribute('data-c');
    [].forEach.call(tog,function(x){x.setAttribute('aria-pressed',x===b?'true':'false')});
    [].forEach.call(r.querySelectorAll('.hx-photo>img[id^="hx-c-"]'),function(im){im.classList.toggle('is-off',im.id!=='hx-c-'+c)});
  });
});
})();
